<div class="min-h-[calc(100vh-64px)] bg-neutral-50 p-4 md:p-6 dark:bg-neutral-900">
  <div class="mb-4 md:mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <h1 class="text-2xl font-bold text-neutral-900 dark:text-white">
      Templates de etiquetas
    </h1>
    <app-button
      color="primary"
      [icon]="'plus'"
      [routerLink]="['/tagging/campaign/new']"
    >
      Novo template
    </app-button>
  </div>

  @if (error) {
    <app-alert type="danger" class="mb-4">{{ error }}</app-alert>
  }

  @if (paginationState().loading) {
    <div class="mb-4">
      <app-loading size="large" color="primary" />
    </div>
  }

  @if (!paginationState().loading && templates.length > 0) {
    <div class="overflow-x-auto rounded-2xl border border-neutral-200 bg-white shadow-sm dark:border-neutral-800 dark:bg-neutral-800">
      <table class="table-auto w-full border-collapse">
        <thead>
          <tr class="bg-neutral-100 dark:bg-neutral-700">
            <th class="border-b border-neutral-200 px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-neutral-700 dark:border-neutral-600 dark:text-neutral-300">
              ID
            </th>
            <th class="border-b border-neutral-200 px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-neutral-700 dark:border-neutral-600 dark:text-neutral-300">
              Nome
            </th>
            <th class="border-b border-neutral-200 px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-neutral-700 dark:border-neutral-600 dark:text-neutral-300">
              Descrição
            </th>
            <th class="border-b border-neutral-200 px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-neutral-700 dark:border-neutral-600 dark:text-neutral-300">
              Largura (mm)
            </th>
            <th class="border-b border-neutral-200 px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-neutral-700 dark:border-neutral-600 dark:text-neutral-300">
              Altura (mm)
            </th>
            <th class="border-b border-neutral-200 px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-neutral-700 dark:border-neutral-600 dark:text-neutral-300">
              Status
            </th>
            <th class="border-b border-neutral-200 px-6 py-3 text-right text-xs font-semibold uppercase tracking-wider text-neutral-700 dark:border-neutral-600 dark:text-neutral-300">
              Ações
            </th>
          </tr>
        </thead>
        <tbody>
          @for (t of templates; track t.id; let even = $even) {
            <tr
              [ngClass]="
                even
                  ? 'bg-neutral-50 dark:bg-neutral-800'
                  : 'bg-white dark:bg-neutral-900'
              "
              class="border-b border-neutral-100 transition hover:bg-neutral-100 dark:border-neutral-700 dark:hover:bg-neutral-700/50"
            >
              <td class="px-6 py-4 text-sm font-mono text-neutral-900 dark:text-neutral-100">
                {{ t.id }}
              </td>
              <td class="px-6 py-4 text-sm font-medium text-neutral-900 dark:text-white">
                {{ t.name }}
              </td>
              <td class="px-6 py-4 text-sm text-neutral-600 dark:text-neutral-400">
                {{ t.description || '-' }}
              </td>
              <td class="px-6 py-4 text-sm text-neutral-900 dark:text-neutral-100">
                {{ t.width }}
              </td>
              <td class="px-6 py-4 text-sm text-neutral-900 dark:text-neutral-100">
                {{ t.height }}
              </td>
              <td class="px-6 py-4">
                <span
                  class="inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium"
                  [ngClass]="
                    t.active
                      ? 'bg-green-50 text-green-700 dark:bg-green-900/30 dark:text-green-400'
                      : 'bg-neutral-100 text-neutral-600 dark:bg-neutral-700 dark:text-neutral-400'
                  "
                >
                  {{ t.active ? 'Ativo' : 'Inativo' }}
                </span>
              </td>
              <td class="px-6 py-4 text-right">
                <app-button
                  color="neutral"
                  size="small"
                  [icon]="'edit-2'"
                  [routerLink]="['/tagging/campaign', t.id]"
                  [attr.aria-label]="'Editar template ' + t.name"
                >
                </app-button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <app-pagination
      [paginationState]="paginationState()"
      [onPaginationChange]="onPageChange"
    />
  }

  @if (!paginationState().loading && templates.length === 0) {
    <div
      class="rounded-2xl border border-neutral-200 bg-white p-12 text-center dark:border-neutral-800 dark:bg-neutral-800 center"
    >
      <p class="text-neutral-600 dark:text-neutral-400">
        Nenhum template cadastrado. Clique em "Novo template" para criar o primeiro.
      </p>
      <app-button
        color="primary"
        class="mt-4"
        [icon]="'plus'"
        [routerLink]="['/tagging/campaign/new']"
      >
        Novo template
      </app-button>
    </div>
  }
</div>
